import React from 'react';
import * as Yup from 'yup';
import { Formik, Field, FormikHelpers, FieldProps } from 'formik';
import { Typography, Spin, Input, Button } from 'antd';
import { FormField } from '../../components/FormField';

const { Text } = Typography;
const validationSchema = Yup.object({
  username: Yup.string()
    .email('Username should be a valid email address')
    .required('Username is required'),
  password: Yup.string().required('Password is required'),
});

type FormValues = {
  username: string;
  password: string;
};
type Props = {
  onSubmit: (values: FormValues, actions: FormikHelpers<FormValues>) => any;
};

export const SignInForm = ({ onSubmit }: Props) => {
  return (
    <Formik validationSchema={validationSchema} onSubmit={onSubmit} initialValues={{ username: '', password: '' }}>
      {({ status, isSubmitting, handleSubmit }) => (
        <div style={{ display: 'flex', flexDirection: 'column', padding: '24px 0 0 0' }}>
          {status && <Text type="danger">{status}</Text>}
          <form onSubmit={handleSubmit}>
            <Field name="username">
              {(props: FieldProps) => (
                <FormField {...props}>
                  <Input size="large" placeholder="Username" {...props.field} />
                </FormField>
              )}
            </Field>
            <Field name="password">
              {(props: FieldProps) => (
                <FormField {...props}>
                  <Input.Password size="large" placeholder="Password" {...props.field} />
                </FormField>
              )}
            </Field>

            {isSubmitting ? (
              <div style={{ display: 'flex', justifyContent: 'center', padding: '0 0 24px 0' }}>
                <Spin />
              </div>
            ) : (
              <Button
                style={{ width: '100%' }}
                size="large"
                type="primary"
                htmlType="submit"
                className="login-form-button">
                Log in
              </Button>
            )}
          </form>
        </div>
      )}
    </Formik>
  );
};
